import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	inject,
	Input,
	Output,
} from '@angular/core';

import { MoveToRootDirective } from '~ng-common-lib/cdk/move-to-root.directive';

@Component({
	selector: 'base-modal',
	templateUrl: './base-modal.component.html',
	styleUrl: './base-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, MoveToRootDirective],
})
export class BaseModalComponent {
	private readonly cdRef = inject(ChangeDetectorRef);

	@Input()
	public showClose = false;

	@Input()
	public fullSize = false;

	@Input()
	public closeFromOutside = true;

	@Input()
	public warningModal = false;

	/** When warningModal is true, applied to the inner container (e.g. "560px"). */
	@Input()
	public modalHeight: string | null = null;

	/** When warningModal is true, applied to the inner container (e.g. "528px"). */
	@Input()
	public modalWidth: string | null = null;

	private _opened = false;

	@Input()
	public set opened(opened: boolean) {
		if (typeof opened !== typeof true) {
			return;
		}

		if (this._opened === opened) {
			return;
		}

		this._opened = opened;
		this.openedChanged$$.emit(this._opened);

		this.cdRef.detectChanges();
	}

	public get opened(): boolean {
		return this._opened;
	}

	@Output('openedChanged')
	private readonly openedChanged$$ = new EventEmitter<boolean>();
	public readonly openedChanged$ = this.openedChanged$$.asObservable();

	@Output('closed')
	private readonly closed$$ = new EventEmitter<void>();
	public readonly closed$ = this.closed$$.asObservable();

	@Output('opened')
	private readonly opened$$ = new EventEmitter<void>();
	public readonly opened$ = this.opened$$.asObservable();

	public open(): void {
		this.opened = true;
	}

	public close(): void {
		this.opened = false;
		this.closed$$.emit();
	}

	public toggle(): void {
		this.opened = !this.opened;
	}

	public outsideClick(): void {
		if (this.closeFromOutside) {
			this.close();
			this.closed$$.emit();
		}
	}
}
